module.exports = __webpack_public_path__ + "img/get-started-bg.b5560a3.png";